import Auth from '../modules/Authentication'
import { apiUrl } from '../variables/index'
import { handleErrors, handleResponse } from '../modules/Utils'
import { streamUrl } from '../variables/index'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
export default class Members {
  constructor() {
    this.auth = new Auth()
  }

  phonebook = () => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}members/`, { headers }).then(handleErrors)
  }
  get = (key) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}members/${key}`, { headers }).then(handleErrors)
  }
  representatives = {
    list: (key) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}members/${key}/representatives`, { headers }).then(handleErrors)
    },
    byPartner: (key) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}members/${key}/representatives/byPartner`, {
        headers,
      }).then(handleErrors)
    },
    add: (key, data) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}members/${key}/representatives`, {
        headers,
        method: 'POST',
        body: JSON.stringify(data),
      }).then(handleErrors)
    },
    remove: (key, data) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}members/${key}/representatives`, {
        headers,
        method: 'DELETE',
        body: JSON.stringify(data),
      }).then(handleErrors)
    },
  }
  similar = (word) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}members/similar?word=${word}`, { headers }).then(handleErrors)
  }
  getImage = (key) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}members/${key}/image`, { headers }).then(handleErrors)
  }
  checkImage = (fileID) => {
    return fetch(`${streamUrl}files/${fileID}?action=view&access_token=${this.auth.getAccessToken()}`).then(
      handleErrors
    )
  }
  update = (data) => {
    headers['Authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}members/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    }).then(handleErrors)
  }
  remove = (data) => {
    headers['Authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}members/`, {
      headers: headers,
      method: 'DELETE',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  organisation = () => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}members/list/organisation`, { headers }).then(handleErrors).then(handleResponse)
  }

  organisationFull = () => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}members/list/organisation/full`, { headers }).then(handleErrors).then(handleResponse)
  }
  individual = () => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}members/list/individual`, { headers }).then(handleErrors).then(handleResponse)
  }
  create = (member) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}members/`, {
      headers,
      method: 'POST',
      body: JSON.stringify(member),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  contacts = {
    get: (key) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}members/${key}/contacts`, { headers }).then(handleErrors)
    },
    update: (key, data) => {
      headers['Authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}members/${key}/contacts`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      }).then(handleErrors)
    },
  }
  profiles = {
    get: (owner) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}members/${owner}/profile`, { headers }).then(handleErrors).then(handleResponse)
    },
  }
}
